import React, { useState } from 'react';
import SocialIcons from '../components/SocialIcons/SocialIcons';
import styled from 'styled-components';

export const Divider = styled.div`
  height: 1px;
  width: 60%;
  background-color: #262626;
  margin: 1em 0px;
`;

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 2em 0 0;
`;

export const LoadMoreButton = styled.button`
  padding: 10px 40px;
  border-radius: 4px;
  border: 2px solid #CC0000;
  background-color: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  width: auto;
  display: inline-block;
  text-align: center;
`;

const FormContainer = styled.div`
  flex: 1.7;
  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    max-width: 100%;
  }
  div {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  input, textarea {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    margin-top: 5px;
  }
  textarea {
    height: 100px;
    resize: none;
  }
`;

const ContactUsForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    humanCheck: '',
  });

  const [mathQuestion, setMathQuestion] = useState(generateMathQuestion());
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Funzione per generare operazioni matematiche casuali
  function generateMathQuestion() {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    const answer = num1 + num2;
    return { question: `What is ${num1} + ${num2}?`, answer: answer.toString() };
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Controllo umano
    if (formData.humanCheck !== mathQuestion.answer) {
      setErrorMessage('Per favore, rispondi alla domanda matematica correttamente.');
      return;
    }

    try {
      const response = await fetch('https://rossomotori.it/wp-json/v1/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          message: formData.message,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Errore nell\'invio del messaggio');
      }

      const data = await response.json();
      setSuccessMessage(data.success || 'Messaggio inviato con successo!');
      setErrorMessage('');
      setFormData({
        name: '',
        email: '',
        message: '',
        humanCheck: '',
      });
      setMathQuestion(generateMathQuestion());
    } catch (error) {
      setErrorMessage(error.message || 'Errore nell\'invio del messaggio');
      setSuccessMessage('');
    }
  };

  return (
    <>
      <div style={{ display: 'flex', color: '#262626' }}>
        <div style={{ flex: 0.8, marginRight: '20px', display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
              <h1 style={{ color: '#CC0000' }}>CONTATTACI</h1>
              <Divider />
              <p> Compila il form o seguici sui nostri canali social. Ti risponderemo il prima possibile.</p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
              <h1 style={{ color: '#CC0000' }}>SEGUICI</h1>
              <Divider />
              <div style={{ display: 'flex', gap: '10px' }}>
                <SocialIcons />
              </div>
            </div>
          </div>
        </div>

        <FormContainer>
          <form onSubmit={handleSubmit}>
            <div>
              <label>Nome:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>E-mail:</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div>
              <label>Messaggio:</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <div>
              <label>Sei umano? {mathQuestion.question}</label>
              <input
                type="text"
                name="humanCheck"
                value={formData.humanCheck}
                onChange={handleChange}
                required
              />
            </div>
            {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
            {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>}
            <LoadMoreContainer>
              <LoadMoreButton type="submit">
                <h2 style={{ margin: '0', color: '#CC0000' }}>INVIA</h2>
              </LoadMoreButton>
            </LoadMoreContainer>
          </form>
        </FormContainer>
      </div>
    </>
  );
};

export default ContactUsForm;
